"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HeaderMenuCategory = require("./HeaderMenuCategory");
var HeaderMenu = function HeaderMenu(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? 'header-menu' : _props$className,
    _props$isCompact = props.isCompact,
    isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
    _props$breakpoint = props.breakpoint,
    breakpoint = _props$breakpoint === void 0 ? 1250 : _props$breakpoint,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(Menu, {
    breakpoint: breakpoint,
    isCompact: isCompact,
    className: className
  }, children);
};
var Menu = _styledComponents["default"].ul.withConfig({
  displayName: "HeaderMenu__Menu",
  componentId: "sc-zwy0b9-0"
})(["display:flex;color:#fff;font-size:14px;", " ", ""], function (_ref) {
  var isCompact = _ref.isCompact;
  return isCompact && "\n  ".concat(_HeaderMenuCategory.CategoryName, " {\n      display: none;\n    }\n  ");
}, function (_ref2) {
  var breakpoint = _ref2.breakpoint,
    isCompact = _ref2.isCompact;
  return (breakpoint || isCompact) && "\n      @media screen and (max-width: ".concat(breakpoint || 1250, "px) {\n        ").concat(_HeaderMenuCategory.CategoryName, " {\n          display: none;\n        }\n      }\n    ");
});
var _default = exports["default"] = HeaderMenu;